<template>
  <div class="flex_vertial">
    <div style="flex:1;"></div>
    <img class="robot" src="../../assets/irobot2.png">
    <div class="head_title">最后，拨打本机号码<br>检查助理是否已上线为你接听</div>
    <div class="head_title_gray">温馨提示：助理默认声音为女声</div>
    <div style="flex:4;"></div>
    <div v-if="num" class="open_button" @click="calltest" style="text-decoration: none">拨打本机号码</div>
    <div class="help_layout" @click="help">
      <div class="help">开通失败帮助</div>
      <img class="help_arch" src="@/assets/arrow2.png">
    </div>

  </div>
</template>

<script>
import app from '@/AppData'
import util from '@/utils/util'
import jsbridge from '@/jsbridge'
import lubanApi from '@/lubanApi'

export default {
  name: 'bindGuidePage',
  data () {
    return {num: ''}
  },
  methods: {
    calltest () {
      jsbridge.setAiRedirectCall(this.num).then(res => {
        this.$router.replace({
          path: '/bind_dail_try_verify'
        })
      }).catch(err => {
      })
      lubanApi.reportseer('AICall_Open_Function_Complete_Page_Experience_Button_Click')
    },
    help () {
      util.openHelpWeb()
      lubanApi.reportseer('AICall_Open_Function_Complete_Page_Help_Button_Click')
    }
  },
  mounted () {
    if (!util.isEmpty(app.getData().tryToBindNum)) {
      this.num = app.getData().tryToBindNum
    } else {
      this.num = app.getData().userSetting.phoneNum
    }
    lubanApi.reportseer('AICall_Open_Function_Complete_Page_Shown')
  }
}
</script>

<style scoped lang="less" src="@/styles/common.less"/>
<style scoped>
.robot {
  width: 11rem;
  height: 11rem;
}

.help_layout {
  display: flex;
  margin-bottom: 1rem;
  /*margin-top: -1rem;*/
  align-content: center;
  align-items: center;
}

.help {
  height: 1.25rem;
  font-family: PingFangSC-Regular;
  font-size: 0.9rem;
  line-height: 1.25rem;
  color: #999999;
  letter-spacing: 0;
  text-align: center;
}

.help_arch {
  width: 0.8rem;
  height: 0.8rem;
  margin-left: 0.5rem;
  margin-bottom: 0.1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/bind/BindDailTry.vue